/* eslint-disable */

import React, { Component } from 'react';
import Tables from '../Tables';
import Headers from '../Headers';
// import pubsub from 'pubsub-js';
// import axios from 'axios';
import callMe from '../callApi';
import Singleton from '../../sock';
import DisplayError from '../../DisplayError';
import fetchBookNo from '../fetchCode';
import { ToastContainer } from 'react-toastr';

const theaders = ['Book', 'Title', 'Current Location', 'Shelf Location',
    'Book Status', 'Original Location', 'Ibt Status', 'Requested Branch', "Category", "SubCategory"];

const mHeaders = ['number', 'titleName', 'currentLocation', 'shelfLocation',
    'status', 'origLocation', 'ibt', 'requestedBranchId', 'bookMainCategory', 'bookCategory'];

var count = 0;

var booknos = [];
function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
//returns true if object is empty
// function isEmpty(obj) {
//     for(var key in obj) {
//         if(obj.hasOwnProperty(key))
//             return false;
//     }
//     return true;
// }

class SortBooks extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bookno: '',
            tData: {},
            reset: false,
            errorVisible: false,
            errorDesc: null,
        }
        this.handleRefresh = this.handleRefresh.bind(this);
        // console.log(sessionStorage.getItem('hi'));
    }

    handleRefresh() {
        this.input.value = 0;
        booknos = [];
        this.setState({
            reset: !this.state.reset,
            tData: {},
            errorVisible: false
        });
    }

    componentWillMount() {
        console.log('sortbooks will mount connection will begin');

        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount() {
        console.log('sortbooks did mount, receive msg here');
        this.sock.onmessage = msg => {
            if (typeof (msg.data) === 'string') {
                this.fetchCode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");

        }

    }
    componentWillUnmount() {
        booknos = [];
        console.log('sortbook unmount connection will be closed now');
        Singleton.closeSocket(this.sock);

    }

    fetchCode(value) {
        var obj = {
            value: value,
            bookno: booknos,
            start: true,
            callingFrom: "sort"
        };
        fetchBookNo(obj).then(res => {
            console.log(res);
            if (res.error) {
                this.refs.container.error(res.data)
                // this.setState({
                //     errorDesc:res.data,
                //     errorVisible:res.error
                // });
            }
            else {
                this.setState({ tData: res.data })
            }
            booknos = res.bookno;
        }).catch(err => {
            console.log(err);

            return;
        });


        // console.log('fetchcode of sortbook called value => '+value+' ');
        // if(booknos.includes(value)){
        //     console.log('match');
        //     return;
        // }
        // else{
        //     console.log('no  match');
        //     booknos.push(value);

        //     console.log(booknos);    
        //     var callingFrom = 'sort';
        //     callMe(value, callingFrom).then(tableData =>{
        //         if(!isEmpty(tableData) && tableData.status){
        //             this.setState({
        //                 tData:tableData,
        //                 errorVisible:false
        //             });
        //         }
        //         else{
        //             if(!tableData.success)
        //                 this.setState({errorVisible:true,errorDesc:tableData.errorDesc})
        //         }
        //     })
        //     .catch(err =>{
        //         console.log(err);
        //     });
        // }
    }


    render() {
        return (
            <div>

                <Headers
                    hname="Sort Books"
                />
                <ToastContainer
                    ref="container"
                    className="toast-top-right"
                />
                <DisplayError
                    errorVisible={this.state.errorVisible}
                    errorDesc={this.state.errorDesc}
                />

                <div className="pull-right">
                    <label htmlFor="count" >Count:</label>
                    <input type="text" style={{ margin: 5, width: 50 }} ref={(input) => this.input = input} name="count" id="count" readOnly />
                </div>
                <div>
                    <Tables
                        headers={theaders}
                        mHeaders={mHeaders}
                        displayCount={this.input}
                        body={this.state.tData}
                        resetTable={this.state.reset}
                    />
                </div>
                <div className="row">
                    <div className="col-sm-4"></div>
                    <div className="col-xs-4">
                        <div className="btngroup btn-toolbar">
                            <button className="btn relativepos" type="button" onClick={this.handleRefresh}>Refresh</button>
                        </div>
                    </div>
                    <div className="col-lg-4"></div>
                </div>
            </div>
        )
    }
}

export default SortBooks;


// WEBPACK FOOTER //
// ./src/Components/SortBooks/SortBook.js